import { DefecationFactory } from './defecationFactory';

import type {
  DefecationEntity,
  DefecationPropsPub,
  DefecationPropsPvt,
} from './defecationEntity';
import type { DefecationIRepository } from './defecationIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { DefecationJsonPub, DefecationJsonPvt } from '@/types/domain/defecation/entities/defecationEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class DefecationRepository extends AppsyncRepository<
  DefecationEntity,
  DefecationPropsPvt,
  DefecationJsonPvt,
  DefecationPropsPub,
  DefecationJsonPub
> implements DefecationIRepository {
  private factory = new DefecationFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppDefecationDefecationEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
